import React from 'react';
import { WarningIcon } from '../../icons';
import { useTranslation } from 'react-i18next';
import { Toaster } from '../Toaster';
import './CloseConfirmationToaster.scss';
export const CloseConfirmationToaster = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const handleLeaveVerification = () => {
        window.location.replace(window.avAppConfig.registrationUrl);
    };
    return (React.createElement(Toaster, { isOpen: isOpen, onClose: onClose },
        React.createElement("div", { className: "close-confirmation-toaster" },
            React.createElement(WarningIcon, { width: 64, height: 64, fill: "#FCE1A4" }),
            React.createElement("h2", { className: "close-confirmation-toaster__title" }, t('close_toaster.title')),
            React.createElement("p", { className: "close-confirmation-toaster__description" }, t('close_toaster.description')),
            React.createElement("p", { className: "close-confirmation-toaster__description" }, t('close_toaster.subDescription')),
            React.createElement("div", { className: "close-confirmation-toaster__buttons" },
                React.createElement("button", { type: "button", className: "close-confirmation-toaster__buttons__button", onClick: onClose }, t('close_toaster.cancel')),
                React.createElement("button", { type: "button", className: "close-confirmation-toaster__buttons__button close-confirmation-toaster__buttons__button--exit", onClick: handleLeaveVerification }, t('close_toaster.exit'))))));
};
//# sourceMappingURL=CloseConfirmationToaster.js.map